import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ZbirniDnevnik } from './zbirni-dnevnik';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-zbirni-dnevnik',
  templateUrl: './zbirni-dnevnik.component.html'
})
export class ZbirniDnevnikComponent 
extends BaseModalContainer<ZbirniDnevnik> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<ZbirniDnevnik>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
